import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { HeartPulse } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function loginWithGoogle() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-xl bg-[#4A6750] flex items-center justify-center">
            <HeartPulse className="w-5 h-5 text-white" strokeWidth={1.5} />
          </div>
          <span className="font-heading text-xl font-semibold text-[#1C2E24]">Verda Health</span>
        </Link>

        <Card className="p-8 rounded-2xl border-[#E5E7E4] shadow-sm">
          <h1 className="font-heading text-3xl font-semibold text-[#1C2E24]">Welcome</h1>
          <p className="text-sm text-[#5C6D63] mt-2">
            Sign in or create your account with Google. It&apos;s the only way in — nothing to remember, nothing to leak.
          </p>

          <Button onClick={loginWithGoogle} data-testid="login-google-btn"
            className="w-full h-12 rounded-xl bg-white hover:bg-[#F9F8F6] text-[#1C2E24] border border-[#E5E7E4] font-medium mt-6">
            <GoogleIcon /> <span className="ml-2">Continue with Google</span>
          </Button>

          <p className="text-[11px] text-[#7D8F84] mt-5 leading-relaxed">
            By continuing you agree to our terms and consent to store health records under India&apos;s DPDP Act.
            You can withdraw consent or delete your account any time from Privacy &amp; Data.
          </p>
        </Card>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden>
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.75h3.57c2.08-1.92 3.28-4.74 3.28-8.07z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.75c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.12c-.22-.66-.35-1.36-.35-2.12s.13-1.46.35-2.12V7.04H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.96l3.66-2.84z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.04l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
    </svg>
  );
}
